module.exports = __webpack_public_path__ + "static/media/acapulco.613edb50.jpg";